import { define } from '@components/Component.js'
import { h } from '@core/dom.js'

const section = (title, ...children) =>
    h('div', { className: 'adm-guide__section' },
        h('h3', { className: 'adm-guide__heading' }, title),
        ...children)

const step = (num, bold, desc) =>
    h('div', { className: 'adm-guide__step' },
        h('span', { className: 'adm-guide__num' }, num),
        h('div', {},
            h('strong', {}, bold),
            desc ? h('p', { className: 'adm-guide__desc' }, desc) : null))

const rule = text => h('li', { className: 'adm-guide__rule', innerHTML: '→ ' + text })

const callout = (type, text) =>
    h('div', { className: `adm-guide__callout adm-guide__callout--${type}`, innerHTML: text })

define('AdminGuide', () => {
    return h('div', { className: 'adm-guide' },
        h('h2', { className: 'adm-guide__title' }, 'Guía para publicar anuncios'),
        h('p', { className: 'adm-guide__lead' }, 'Paso a paso desde que llega la solicitud hasta que aparece en el sitio.'),

        section('Flujo completo de publicación',
            step('1', 'El cliente llena el formulario en /registrar',
                'Elige plan (Oro, Plata o Promoción), sube imágenes y envía. Se genera un JSON que llega a GitHub y como respaldo al correo.'),
            step('2', 'Abrir el Admin → pestaña Solicitudes',
                'Ir a /admin, ingresar la contraseña. En la pestaña Solicitudes aparecen las solicitudes pendientes.'),
            step('3', 'Aprobar la solicitud',
                'Al aprobar, el negocio o promo se importa a la pestaña correspondiente en estado deshabilitado. La solicitud se elimina automáticamente.'),
            step('4', 'Revisar y editar en la pestaña Negocios o Promociones',
                'Verificar que los datos estén bien: nombre, descripción, imágenes, WhatsApp, redes sociales. Corregir lo que haga falta.'),
            step('5', 'Habilitar el anuncio',
                'Activar el toggle de visibilidad. Solo los habilitados aparecen en el sitio público.'),
            step('6', 'Pulsar "Publicar en el sitio"',
                'Sube todo (negocios + promos) a GitHub en un solo commit. El sitio se actualiza en ~2 minutos.'),
            callout('info', 'Al publicar se sube el listado completo. Si no quieres que un anuncio se vea todavía, simplemente déjalo <strong>deshabilitado</strong>.')
        ),

        section('Reglas importantes',
            h('ul', { className: 'adm-guide__rules' },
                rule('<strong>No publiques a medias.</strong> Revisa nombre, imagen, WhatsApp y redes antes de habilitar.'),
                rule('<strong>WhatsApp siempre con código de país.</strong> Formato correcto: <code>573124288323</code> (57 + número). Si ponen 0312… el sistema lo corrige.'),
                rule('<strong>Redes sociales como URL completa.</strong> Formato: <code>https://instagram.com/usuario</code>. Si ponen @usuario, el sistema lo normaliza.'),
                rule('<strong>No apruebes la misma solicitud dos veces.</strong> El sistema bloquea duplicados, pero revisa la pestaña Negocios antes de aprobar.'),
                rule('<strong>Publicar = todo se sube.</strong> No hay publicación selectiva. Usa el toggle habilitado/deshabilitado para controlar qué aparece.'),
                rule('<strong>Después de publicar, recarga el admin.</strong> El localStorage se limpia automáticamente. Al recargar verás los datos frescos.')
            ),
            callout('danger', '<strong>Nunca edites los JSON directamente en GitHub</strong> a menos que sepas lo que haces. Usa siempre el panel admin.')
        ),

        section('Tipos de anuncio',
            h('div', { className: 'adm-guide__table-wrap' },
                h('table', { className: 'adm-guide__table' },
                    h('thead', {},
                        h('tr', {},
                            h('th', {}, 'Plan'),
                            h('th', {}, 'Qué incluye'),
                            h('th', {}, 'Visible como'))),
                    h('tbody', {},
                        h('tr', {},
                            h('td', {}, h('span', { className: 'adm-guide__tag adm-guide__tag--oro' }, 'Oro')),
                            h('td', {}, 'Página completa: galería (10 fotos), video, catálogo, mapa, reseñas, redes sociales'),
                            h('td', {}, 'Tarjeta destacada + página propia')),
                        h('tr', {},
                            h('td', {}, h('span', { className: 'adm-guide__tag adm-guide__tag--plata' }, 'Plata')),
                            h('td', {}, 'Tarjeta en directorio: imagen, descripción, WhatsApp, ubicación, 4 fotos'),
                            h('td', {}, 'Tarjeta en el listado del directorio')),
                        h('tr', {},
                            h('td', {}, h('span', { className: 'adm-guide__tag adm-guide__tag--promo' }, 'Promo')),
                            h('td', {}, 'Banner de promoción: imagen, título, descripción, vencimiento, redes'),
                            h('td', {}, 'Sección de promociones + página propia'))))
            )
        ),

        section('Si algo sale mal',
            h('ul', { className: 'adm-guide__rules' },
                rule('<strong>Negocios duplicados en el admin:</strong> Pulsa "Descartar cambios" en la barra superior y recarga la página.'),
                rule('<strong>El sitio no muestra un anuncio publicado:</strong> Verifica que esté habilitado y que los datos estén actualizados (recarga el admin).'),
                rule('<strong>WhatsApp no funciona:</strong> Revisa que el número tenga formato <code>57XXXXXXXXXX</code> (10 dígitos después del 57).'),
                rule('<strong>Redes sociales llevan a URL rara:</strong> Edita el negocio y pon la URL completa (<code>https://instagram.com/…</code>).')
            )
        )
    )
})
